<template>
  <basic-portlet title="Legacy Settings" icon="la la-lock" :bordered="true">
    <div class="form-group row">
      <div class="col-lg-12">
        <label>AutoFill</label>
        <div class="kt-input-icon">
          <multiselect id="template" v-model="legacyUserSelected"
                       :show-no-results="false" :allow-empty="true"
                       :options-limit="5"
                       :options="legacyUsers"
                       label="username" @input="selectLegacyUser"
                       @search-change="listLegacyUsers" @remove="clearLegacyUsers">
            <span slot="noResult">
              Oops! No nothing was found!
            </span>
          </multiselect>

          <span class="kt-input-icon__icon kt-input-icon__icon--right"><span><i class="la la-map-marker" /></span></span>
        </div>
        <span class="form-text text-muted">Select a user to autofill fields below</span>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-lg-6">
        <label>ID</label>
        <input v-model="data_user.legacy_id" type="text"
               name="legacy_id" :class="{'form-control': true, 'kt-input':true, 'has-error': errors.has('legacy_id') }"
               placeholder="Legacy ID" autocomplete="off"
               aria-describedby="basic-addon1">
        <span class="form-text text-muted">Platform v1 ID</span>
      </div>
      <div class="col-lg-6">
        <label class="">Username</label>

        <input v-model="data_user.legacy_username" type="text"
               name="legacy_username" :class="{'form-control': true, 'kt-input':true, 'has-error': errors.has('legacy_username') }"
               placeholder="Full Name" autocomplete="off"
               aria-describedby="basic-addon1">
        <span class="form-text text-muted">Platform v1 Username</span>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-lg-6">
        <label>User Group:</label>
        <div class="kt-radio-inline">
          <label class="kt-radio kt-ratio--solid">
            <input id="one" v-model="data_user.legacy_platform_prod"
                   type="radio"
                   :value="0">
            Development
            <span />
          </label>

          <label class="kt-radio kt-ratio--solid">
            <input id="two" v-model="data_user.legacy_platform_prod"
                   type="radio"
                   :value="1">
            Production
            <span />
          </label>
        </div>
        <span class="form-text text-muted">Select Platform type</span>
      </div>
    </div>

    <template slot="footer">
      <div class="row">
        <div class="col-lg-6">
          <button class="btn btn-ss-standout" @click.prevent="updateLegacy()">
            <i class="fa fa-save" />&nbsp;Save Changes
          </button>
        </div>
      </div>
    </template>
  </basic-portlet>
</template>

<script>
import BasicPortlet from "VueComponents/BasicPortlet";
export default {
  name: "LegacyInfo",
  components: { BasicPortlet },
  props: {
    sidebar: {
      type: Boolean,
      required: false,
    },
    admin: {
      type: Boolean,
      required: false,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      data_user: this.user,
      formIncomplete: false,
      legacyUserSelected: null,
      legacyUsers: [],
    };
  },
  computed: {
    authUserIsAdmin() {
      return typeof auth_user !== "undefined" && window.auth_user.is_admin;
    },
    isUploader() {
      return window.user.is_uploader;
    },
  },
  methods: {
    listLegacyUsers: _.debounce(async function () {
      const response = await axios.get("/api/v1/admin/legacy/users");
      this.legacyUsers = response.data;
    }, 1000),

    async clearLegacyUsers() {
      this.data_user.legacy_id = "";
      this.data_user.legacy_username = "";
      this.data_user.legacy_platform_prod = 0;
    },

    async selectLegacyUser() {
      await this.clearLegacyUsers();
      this.data_user.legacy_id = this.legacyUserSelected.id;
      this.data_user.legacy_username = this.legacyUserSelected.username;
      this.data_user.legacy_platform_prod = 0;
      if (this.legacyUserSelected.production) {
        this.data_user.legacy_platform_prod = 1;
      }
    },

    async updateLegacy() {
      const form_data = {
        legacy_id: this.data_user.legacy_id,
        legacy_data_username: this.data_user.legacy_username,
        legacy_platform_prod: this.data_user.legacy_platform_prod,
        user_id: this.data_user.uuid,
        is_super_admin: this.data_user.is_super_admin,
      };
      const result = await this.$validator.validateAll();
      if (result) {
        try {
          await axios.put(
            `/api/v1/user/${this.data_user.uuid}`,
            form_data,
          );
          toastr.success("Legacy Information updated!");
        } catch (error) {
          window.handleAxiosError(error);
        }
      } else {
        toastr.error("Some fields have not been completed correctly");
      }
    },
  },
};
</script>

<style scoped lang='scss'>
.input-container {
    margin-bottom: 20px;
}
.control-label {
    padding-top: 7px;
    margin-bottom: 0;
    text-align: right;
}

.input-group-addon {
    color: #c5cdda;
    min-width: 40px;
}

input.has-error {
    border: 1px solid #e73d4a;
}

p.is-danger {
    margin-top: 5px;
    color: #e73d4a;
}
</style>
